<!-- 结算操作 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">账期时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                        style="width:240px"
                    ></el-date-picker>
                    <div class="search-name">申请备注</div>
                    <el-input class="search-item" size="small" style="width:580px" v-model.trim="submitData.Remark" placeholder="请输入备注内容"></el-input>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border=""
                ref="multipleTable"
                height="400px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column show-overflow-tooltip width="52" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                        <i v-else class="out-active">采购退货</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="TotalAmount" label="应付总额">
                    <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Balance" label="余额"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注"></el-table-column>
                <el-table-column label="操作" width="60">
                    <template slot-scope="scope">
                        <div>
                            <el-button title="移除" size="small" type="text" @click="delItem(scope.row)" style="color: red">移除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer">
            <div class="re-submit">
                <el-button class="btn-primary" @click="submitForm()">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['ApplyList'],
    components: {},
    data() {
        return {
            loading: false,
            dateTimes: [],
            submitData: {
                RecordIds: [],
                StartDate: '',
                EndDate: '',
                Remark: ''
            },
            tableData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.ApplyList && this.ApplyList.length > 0) {
            this.tableData = this.ApplyList;
            let balance = 0;
            for (let index = 0; index < this.tableData.length; index++) {
                this.submitData.RecordIds.push(this.tableData[index].RecordId);
                if (this.tableData[index].OrderType == 0) balance += this.tableData[index].TotalAmount;
                else balance -= this.tableData[index].TotalAmount;
                balance = balance.toFixed(2) * 1;
                this.tableData[index].Balance = balance;
            }
        } else this.$util.warningMsg('申请数据异常，请刷新后重新操作');
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.submitData.StartDate = val[0];
                this.submitData.EndDate = val[1];
            } else {
                this.submitData.StartDate = '';
                this.submitData.EndDate = '';
            }
        },
        submitForm() {
            let that = this;
            if (that.submitData.RecordIds.length == 0) {
                that.$util.warningMsg('必须具备申请条目');
                return;
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_N/SubmitSettlementDatas',
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    that.$util.successMsg(res.errmsg);
                    if (res.errcode === 0) {
                        that.$emit('closeDialog', that.submitData.RecordIds);
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        delItem(item) {
            let that = this;
            if (item) {
                that.submitData.RecordIds.splice(that.submitData.RecordIds.indexOf(item.RecordId), 1);
                that.tableData.splice(that.tableData.indexOf(item), 1);

                if (that.tableData.length > 0) {
                    let balance = 0;
                    for (let index = 0; index < this.tableData.length; index++) {
                        if (this.tableData[index].OrderType == 0) balance += this.tableData[index].TotalAmount;
                        else balance -= this.tableData[index].TotalAmount;
                        balance = balance.toFixed(2) * 1;
                        this.tableData[index].Balance = balance;
                    }
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.re-submit {
    text-align: right;
}
.flex {
    padding-top: 10px;
}
</style>
